exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-delatnost-js": () => import("./../../../src/pages/delatnost.js" /* webpackChunkName: "component---src-pages-delatnost-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakt-js": () => import("./../../../src/pages/kontakt.js" /* webpackChunkName: "component---src-pages-kontakt-js" */),
  "component---src-pages-skola-zavarivanja-js": () => import("./../../../src/pages/skola-zavarivanja.js" /* webpackChunkName: "component---src-pages-skola-zavarivanja-js" */)
}

